/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextpostpromptlabel4Inputs */

const en_aitextpostpromptlabel4 = /** @type {(inputs: Aitextpostpromptlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the post about?`)
};

const de_aitextpostpromptlabel4 = /** @type {(inputs: Aitextpostpromptlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worum geht es im Beitrag?`)
};

/**
* | output |
* | --- |
* | "What is the post about?" |
*
* @param {Aitextpostpromptlabel4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextpostpromptlabel4 = /** @type {((inputs?: Aitextpostpromptlabel4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextpostpromptlabel4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextpostpromptlabel4(inputs)
	return de_aitextpostpromptlabel4(inputs)
});
export { aitextpostpromptlabel4 as "aiTextPostPromptLabel" }